import React, {useState} from 'react';
import BottomMenuBar from './BottomMenuBar';
import EmailForm from './EmailForm';
import Collage from './Collage';
import BackArrow from './BackArrow';

import budva from '../images/Budva.jpg';
import cambodia from '../images/Cambodia.jpg';
import cambodia2 from '../images/Cambodia2.jpg';
import falkenberg from '../images/Falk.jpg';
import idaho from '../images/Idaho.jpg';
import iledsm1 from '../images/IleDSM.jpg';
import iledsm2 from '../images/IleDSM2.jpg';
import iledsm3 from '../images/IleDSM3.jpg';
import jackson from '../images/Jackson.jpg';
import kebnekaise from '../images/Kebne.jpg';
import middlebury from '../images/Midd.jpg';
import qutub from '../images/Qutub.jpg';
import saigon from '../images/Saigon.jpg';
import stockholm from '../images/Stockholm.jpg';
import tetons from '../images/Tetons.jpg';

// Picks up every "WhatsApp Image ..." file in the images folder, so new ones are added automatically
const whatsappContext = require.context('../images', false, /WhatsApp Image.*\.jpe?g$/);
const whatsappImages = whatsappContext.keys().map((key) => ({ src: whatsappContext(key), alt: 'Travel photo' }));

function MosaicGallery() {
  const imageList = [
    { src: budva, alt: 'Montenegro' },
    { src: cambodia, alt: 'Cambodia' },
    { src: cambodia2, alt: 'Cambodia' },
    { src: falkenberg, alt: 'Sweden' },
    { src: idaho, alt: 'Idaho' },
    { src: iledsm1, alt: 'France' },
    { src: iledsm2, alt: 'France' },
    { src: iledsm3, alt: 'France' },
    { src: jackson, alt: 'Wyoming' },
    { src: kebnekaise, alt: 'Sweden' },
    { src: middlebury, alt: 'Vermont' },
    { src: qutub, alt: 'India' },
    { src: saigon, alt: 'Vietnam' },
    { src: stockholm, alt: 'Sweden' },
    { src: tetons, alt: 'Wyoming' },
    ...whatsappImages,
  ];

  // Inline styles for the gallery container
  const styles = {
    pageContainer: {
      textAlign: 'center',
      padding: '46px 16px 90px', // Bottom padding keeps the last images clear of the menu bar
      minHeight: '100vh',
      boxSizing: 'border-box',
      backgroundColor: '#f7f7f7',
    },
    title: {
      fontSize: 'clamp(1.6rem, 6vw, 2.5rem)',
      fontWeight: 'bold',
      margin: '10px 0 30px',
      color: '#333',
    },
  };
  const [isEmailVisible, setisEmailVisible] = useState(false);
  const toggleEmailVisibility = () => {
    setisEmailVisible(!isEmailVisible);
  };

  return (
    <div style={styles.pageContainer}>
      <BackArrow />
      <h1 style={styles.title}>Pictures of Wonderful Places</h1>
      <Collage images={imageList}/>

      {isEmailVisible && <EmailForm onClose={toggleEmailVisibility} />}
      <BottomMenuBar onShowBox={toggleEmailVisibility}/>
    </div>
  );
}

export default MosaicGallery;
